module.exports = __webpack_public_path__ + "img/Room5_003.b3c5ca41.svg";